import { IAdvantagesSchema } from '../../../repositories/developer-card/entities/developer_special_promo/AdvantagesSchema';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoAdvantages(state: IApplicationState): IAdvantagesSchema | undefined {
  return getTemplateSpecialPromo(state)?.advantages;
}
